import { useState } from 'react';
import dayjs from 'dayjs';
import { getFromTo } from '../../features/Devices/consumption/utils';

export const PERIOD = { DAY: 'day', MONTH: 'month', YEAR: 'year' };
export const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

const useEventsControl = () => {
  const today = dayjs();

  const [period, setPeriod] = useState(PERIOD.MONTH);
  const [day, setDay] = useState(dayjs().date());
  const [month, setMonth] = useState(dayjs().month());
  const [year, setYear] = useState(dayjs().year());
  const { from, to } = getFromTo(period === PERIOD.DAY ? { year, month, day } : period === PERIOD.MONTH ? { year, month } : { year });

  const handleNext = () => {
    if (period === PERIOD.DAY) {
      const newDate = dayjs(new Date(year, month, day)).add(1, 'day');
      if (newDate.isAfter(today, 'day')) return;
      setDay(newDate.date());
      setMonth(newDate.month());
      setYear(newDate.year());
    } else if (period === PERIOD.MONTH) {
      const newMonth = month + 1;
      if (newMonth > 11) {
        setMonth(0);
        setYear(year + 1);
      } else {
        setMonth(newMonth);
      }
    } else {
      if (year < today.year()) setYear(year + 1);
    }
  };

  const handlePrev = () => {
    if (period === PERIOD.DAY) {
      const newDate = dayjs(new Date(year, month, day)).subtract(1, 'day');
      setDay(newDate.date());
      setMonth(newDate.month());
      setYear(newDate.year());
    } else if (period === PERIOD.MONTH) {
      const newMonth = month - 1;
      if (newMonth < 0) {
        setMonth(11);
        setYear(year - 1);
      } else {
        setMonth(newMonth);
      }
    } else {
      setYear(year - 1);
    }
  };
  return { period, setPeriod, month, setMonth, year, setYear, from, to, day, setDay, handleNext, handlePrev };
};

export default useEventsControl;
